import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  NF_TEST,
  LA_TEST,
  RR_TEST,
} from '../../constants.js';
import {
  addClient
} from '../../actions/advisor';
import s from './AddClientForm.css';

const blankClient = {
  firstName: '',
  lastName: '',
  email: '',
  tests: [NF_TEST,LA_TEST,RR_TEST],
};

class AddClientForm extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      client: blankClient,
    };
  }

  // update the value to state for form text fields
  addClientFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
    } = target;
    const newClient = Object.assign({}, this.state.client);
    newClient[name] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // add/remove tests from the state tests array
  toggleSelectedTests(event, name) {
    event.preventDefault();
    const newClient = Object.assign({}, this.state.client);
    const uTests = Object.assign([], newClient.tests);
    const index = uTests.indexOf(name);
    if (index === -1) {
      uTests.push(name);
    } else {
      uTests.splice(index, 1);
    }
    newClient.tests = uTests;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  // add a new client with current saved state values
  addClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    if(client.firstName !== '' && client.lastName !== '' && client.email !== '') {
      this.props.addClient(client);
      this.setState(Object.assign({}, this.state, {
        client: blankClient,
      }));
    }
  }

  // render out the select tool buttons with on/off css state
  renderToolButton(name) {
    let title = '';
    switch(name) {
      case NF_TEST:
        title = 'Big Picture Assessment';
        break;
      case LA_TEST:
        title = 'Loss Aversion';
        break;
      case RR_TEST:
        title = 'Retirement Regret';
        break;
      default:
        break;
    }
    if (this.state.client.tests.includes(name)) {
      return (
        <button
          onClick={(event) => this.toggleSelectedTests(event, name)}
          className={s.toolButton + ' ' + s.toolButtonOn}
        >{title}</button>
      );
    } else {
      return (
        <button
          onClick={(event) => this.toggleSelectedTests(event, name)}
          className={s.toolButton + ' ' + s.toolButtonOff}
        >{title}</button>
      );
    }
  }

  render() {
    return (
      <div>
        <form>
          <div className="row">
            <div className="col-md-12">
              <div className={s.lineRow}></div>
            </div>
          </div>
          <div className={'row'}>
            <div className="col-md-10">
              <div className={'form-group row'}>
                <div className="col-md-4">
                  <input
                    name="firstName"
                    value={this.state.client.firstName}
                    onChange={this.addClientFormChange}
                    type="text" className={s.formFieldText + ' form-control'}
                    placeholder="First Name"
                  />
                </div>
                <div className="col-md-4">
                  <input
                    name="lastName"
                    value={this.state.client.lastName}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'}
                    placeholder="Last Name"
                  />
                  </div>
                <div className="col-md-4">
                  <input
                    name="email"
                    value={this.state.client.email}
                    onChange={this.addClientFormChange}
                    type="text"
                    className={s.formFieldText + ' form-control'}
                    placeholder="Email"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <button
                onClick={this.addClient}
                className={s.addClientButton}
              >ADD CLIENT</button>
            </div>
          </div>
          <div className={'row'}>
            <div className="col-md-10">
              <div className={'form-group row'}>
                <div className="col-md-4">
                  {this.renderToolButton(NF_TEST)}
                </div>
                <div className="col-md-4">
                  {this.renderToolButton(LA_TEST)}
                </div>
                <div className="col-md-4">
                  {this.renderToolButton(RR_TEST)}
                </div>
              </div>
            </div>
            <div className="col-md-2">
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  addClient,
})(AddClientForm);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/AddClientForm.js